import { getPropertyState } from './../containers/properties/properties.selectors';
import { Store, select } from '@ngrx/store';
import { NgxPermissionsService } from 'ngx-permissions';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../containers/auth/auth.service';


@Injectable()
export class RedirectGuard implements CanActivate {


    constructor(
        public auth: AuthService,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public store: Store<any>,
        public permissionsService: NgxPermissionsService,
    ) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const permissions = this.permissionsService.getPermissions();
            let path: Array<any> = [];

            if (permissions['PROPERTY_LIST']) {
                path = ['/properties']
            } else if (permissions['BUSINESS_LIST']) {
                path = ['/businesses']
            } else if (permissions['MAP_DASHBOARD']) {
                path = ['/map']
            } else if (permissions['DASHBOARD']) {
                path = ['/dashboard']
            } else if (permissions['REPORTS_DASHBOARD']) {
                path = ['/reports']
            } else if (permissions['ADMIN_PANEL']) {
                path = ['/admin']
            } else if (permissions['AUDIT_LOG_LIST']) {
                path = ['/audit-logs']
            }

            if (path.length) {
                this.router.navigate(path)
            }

            resolve(true)
        });
    }
}